module.exports = __webpack_public_path__ + "static/img/234.7b6e8e5e.png";